// Each barber has their own copy of a service (a merchant service, with their own
// price), linked to the shared business service. Moving an appointment to another
// barber means swapping every service for that barber's copy of it.
const businessServiceId = (service: any) =>
    service?.businessService?.id ?? service?.business_service?.id;

export function swapServicesToEmployee(services: any[], employee: any) {
    const offered = (employee?.services ?? []).filter(
        (ms: any) => !ms?.status || ms.status === "active"
    );

    const swapped: any[] = [];
    const missing: string[] = [];

    for (const service of services) {
        const match = offered.find(
            (ms: any) => businessServiceId(ms) === businessServiceId(service)
        );
        if (match) {
            swapped.push({
                ...match,
                employee: match.employee ?? { id: employee.id, name: employee.name },
            });
        } else {
            missing.push(service?.title ?? "a service");
        }
    }

    return { services: swapped, missing };
}
